"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullNameFieldLogic = void 0;
const pick_1 = __importDefault(require("lodash-es/pick"));
const texts_1 = require("../../texts");
const utils_1 = require("../../sort/utils");
const types_1 = require("@smartsuite/types");
const comparisons_1 = require("../../comparisons/comparisons");
const field_logic_1 = require("../../field-type-registry/field-logic");
const full_name_fieldtype_1 = require("../../safe-field-value/text-fields/full-name-field/full-name.fieldtype");
const clipboard_1 = require("../../clipboard");
const validation_1 = require("../../validation");
const full_name_1 = require("../../utils/full-name");
const fields_1 = require("../../utils/fields");
const intl_1 = require("../../locale/intl");
class FullNameFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "fullnamefield";
        this.label = (0, intl_1.$t)(texts_1.fullNameFieldText.full_name);
        this.icon = "full-name";
        this.iconColor = "#6A849B";
        this.placeholder = (0, intl_1.$t)(texts_1.fullNameFieldText.enter_full_name);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.fullNameFieldText.contact),
            (0, intl_1.$t)(texts_1.fullNameFieldText.first),
            (0, intl_1.$t)(texts_1.fullNameFieldText.last),
        ];
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
        };
        this.fieldValueGetter = new full_name_fieldtype_1.FullNameFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            fullnamefield: clipboard_1.clipboardFullNameSelf,
            userfield: clipboard_1.clipboardUserToFullName,
            textfield: clipboard_1.clipboardTextToFullName,
            recordtitlefield: clipboard_1.clipboardTextToFullName,
            firstcreatedfield: clipboard_1.clipboardCreatedUpdatedToFullName,
            lastupdatedfield: clipboard_1.clipboardCreatedUpdatedToFullName,
            unknownfield: clipboard_1.clipboardTextToFullName,
        };
    }
    get validators() {
        return { required: validation_1.requiredFullNameField };
    }
    getEmptyValue() {
        return types_1.emptyFullNameFieldValue;
    }
    getInitialFieldValue(startValue) {
        return {
            ...types_1.emptyFullNameFieldValue,
            first_name: startValue || "",
        };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            deleteValueOnFirstKeypress: true,
            editorWidth: "299px",
            switchToInputControl: "OnSelectedCellClick",
            saveKeys: ["Enter"],
            hideError: true,
        };
    }
    valueToString(fieldValue, field) {
        return (0, full_name_1.formatFullName)(field, fieldValue);
    }
    processFieldValue(record, slug, _comparison, field) {
        var _a;
        if (isFullNameTitleField(slug)) {
            const titleField = (0, fields_1.getAppFieldBySlug)([field], slug);
            const titleId = (0, fields_1.getValueFromRecordByField)(record, titleField);
            return (0, fields_1.getFieldChoiceLabel)(field, titleId);
        }
        if (isFullNameNestedField(slug)) {
            const nestedField = (0, fields_1.getAppFieldBySlug)([field], slug);
            return (0, fields_1.getValueFromRecordByField)(record, nestedField);
        }
        const fullNameFieldValue = (0, fields_1.getValueFromRecordByField)(record, field);
        const mappedValue = (0, pick_1.default)(fullNameFieldValue, (_a = field.params.display_fields) !== null && _a !== void 0 ? _a : []);
        const displayedTitle = (0, fields_1.getFieldChoiceLabel)(field, mappedValue.title);
        const displayedFirstName = mappedValue.first_name;
        const displayedMiddleName = mappedValue.middle_name;
        const displayedLastName = mappedValue.last_name;
        return [
            displayedTitle,
            displayedFirstName,
            displayedMiddleName,
            displayedLastName,
        ]
            .filter((value) => !!value)
            .join(" ");
    }
    replaceValue(field, record, sourceValue, targetValue, _userPreferences) {
        var _a;
        if (typeof targetValue === "string") {
            return ((_a = (0, fields_1.replaceValueInNestedField)(field, record, targetValue)) !== null && _a !== void 0 ? _a : this.getEmptyValue());
        }
        return targetValue !== null && targetValue !== void 0 ? targetValue : this.getEmptyValue();
    }
    sortKey(fieldValue, field, userPreferences, record, structure, rule) {
        const sortByField = (0, fields_1.getAppFieldBySlug)(structure, rule.field);
        if ((0, fields_1.isFieldNested)(sortByField)) {
            return (0, utils_1.getNestedFieldSortKey)(sortByField, structure, rule, userPreferences, record);
        }
        return super.sortKey(fieldValue, field, userPreferences, record, structure, rule);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    isValueEqual(fieldValue1, fieldValue2, field, userPreferences) {
        if ((fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.first_name) !== (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.first_name)) {
            return false;
        }
        if ((fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.last_name) !== (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.last_name)) {
            return false;
        }
        const { display_fields: displayFields } = field.params;
        const showMiddleName = !!(displayFields === null || displayFields === void 0 ? void 0 : displayFields.includes("middle_name"));
        if (showMiddleName &&
            (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.middle_name) !== (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.middle_name)) {
            return false;
        }
        const showTitle = !!(displayFields === null || displayFields === void 0 ? void 0 : displayFields.includes("title"));
        if (showTitle && (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.title) !== (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.title)) {
            return false;
        }
        return true;
    }
    getNestedFields(field) {
        var _a, _b;
        const nested = (_a = field.nested) !== null && _a !== void 0 ? _a : field.params.nested;
        return ((_b = nested === null || nested === void 0 ? void 0 : nested.filter((child) => { var _a; return (_a = field.params.display_fields) === null || _a === void 0 ? void 0 : _a.includes(child.slug); })) !== null && _b !== void 0 ? _b : []);
    }
}
exports.FullNameFieldLogic = FullNameFieldLogic;
function isFullNameTitleField(slug) {
    const [, childSlug] = slug.split(".");
    return childSlug === "title";
}
function isFullNameNestedField(slug) {
    const [, childSlug] = slug.split(".");
    return !!childSlug && types_1.fullNameFields.includes(childSlug);
}
